/* ----------------------------------------------------------------------------
copy the text of a wrapped element to the clipboard
---------------------------------------------------------------------------- */

export default class CopyToClipboard extends HTMLElement {
	constructor() {
		super();
		this.handleClick = this.handleClick.bind(this);
		this.timeout = null;
	}

	async handleClick() {
		try {
			await navigator.clipboard.writeText(this.source.textContent.trim());
		} catch {
			return;
		}

		this.setAttribute('data-copied', '');
		this.button.textContent = this.copiedLabel;

		window.clearTimeout(this.timeout);
		this.timeout = window.setTimeout(() => {
			this.removeAttribute('data-copied');
			this.button.textContent = this.label;
		}, 2000);
	}

	connectedCallback() {
		this.button = this.querySelector('button');
		this.source = this.querySelector('code, pre, [data-copy-source]');
		if (!this.button || !this.source) return;

		if (!navigator.clipboard) {
			this.button.hidden = true;
			return;
		}

		this.label = this.button.textContent;
		this.copiedLabel = this.getAttribute('data-copied-label') || 'Copied';
		this.button.addEventListener('click', this.handleClick);
	}

	disconnectedCallback() {
		window.clearTimeout(this.timeout);
		if (this.button) {
			this.button.removeEventListener('click', this.handleClick);
		}
	}
}

window.customElements.define('copy-to-clipboard', CopyToClipboard);
